/**
 * 
 * @param {string} roleName 
 */
import { RetRole } from '../components/extras/RoleDropdown/RoleDropdown'
import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = EncryptStorage('secret_key', {
  prefix: '@prefix'
});
const getUserAccessLevelByRoleName = (roleName = "") => {

    switch (roleName.toLowerCase()) {
        case 'colaborador':
        case 'usuario':
            return 1;
        case 'especialista':
            return 2;
        case 'responsavel ferramenta':
            return 3;
        case 'membro et':
            return 4;
        case 'gestor':
            return 5;
        case 'admin fabrica':
            return 7;
        case 'admin corporativo':
            return 9;
        case 'superadmin':
            return 10;
        default:
            return 0;
    }
}

const getUserAccessLevel = () => {

    const systemRole = encryptStorage.getItem('SystemRole')
    if (systemRole == null)
        return 0;

    let systemRoleName = encryptStorage.getItem('SystemRole').name;
    //console.log(systemRoleName)
    if (systemRoleName == 'undefined' || systemRoleName == null)
        systemRoleName = 4;

    //console.log(systemRoleName)
    return getUserAccessLevelByRoleName(systemRoleName);
}

const getUserAccessLevelReal = () => {

    const systemRole = encryptStorage.getItem('SystemRoleReal')
    if (systemRole == null)
        return 0;

    let systemRoleName = encryptStorage.getItem('SystemRoleReal').name;
    //console.log(systemRoleName)
    if (systemRoleName == 'undefined' || systemRoleName == null)
        return 0;

    return getUserAccessLevelByRoleName(systemRoleName);
}

export { getUserAccessLevel, getUserAccessLevelByRoleName, getUserAccessLevelReal};